"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "empty centered",
    style: { "margin-top": "15px", "width": "100%" }
};
const _hoisted_2 = {
    key: 1,
    class: "oplus-table-holder"
};
const _hoisted_3 = { class: "oplus-table-wrapper roles-list" };
const _hoisted_4 = { class: "oplus-table oplus-table-hover" };
const _hoisted_5 = { class: "sticky" };
const _hoisted_6 = { class: "row-sticky" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = {
    key: 0,
    class: "sort handle"
};
const _hoisted_10 = { class: "svg-container oplus-icon" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["href"];
const _hoisted_13 = { style: { "overflow": "visible" } };
const _hoisted_14 = { class: "roles-name-cell d-flex" };
const _hoisted_15 = {
    class: "flex-center tooltip tooltip-right",
    "data-tooltip": "他拠点に同期済み"
};
const _hoisted_16 = { class: "role-label" };
const _hoisted_17 = ["data-tooltip"];
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "role-shift" };
const _hoisted_20 = ["onUpdate:modelValue", "onChange"];
const _hoisted_21 = ["onUpdate:modelValue", "onChange"];
const _hoisted_22 = ["id"];
const _hoisted_23 = ["onClick"];
const vue_3 = require("vue");
const sortablejs_1 = __importDefault(require("sortablejs"));
const sortable_1 = require("../../model/v1/sortable");
const common_1 = require("../../js/common");
const SortIcon_vue_1 = __importDefault(require("../../vue/icons/SortIcon.vue"));
const KebabMenuIcon_vue_1 = __importDefault(require("../../vue/icons/KebabMenuIcon.vue"));
const slotTypesToString_1 = require("../../common/slotTypesToString");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RolesListTable',
    props: {
        roles: {
            type: Array,
            required: true,
        },
        isGroupRolePage: {
            type: Boolean,
            required: true,
        },
    },
    emits: ["edit-role", "update-position", "update-show-count", "update-show-staff-count"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const rolesTableBody = (0, vue_3.ref)(null);
        function renderRoleWageWithSign(wage) {
            if (wage) {
                return `${(0, common_1.roundTwoDecimals)(wage, ",")}円`;
            }
            return 0;
        }
        function textGray(obj) {
            return !obj || obj === "0:00" ? "oplus-gray-text" : "";
        }
        function roleColorStyle(role) {
            if (!role || !role.Color) {
                return;
            }
            return {
                backgroundColor: "#" + role.Color,
                color: "#fff",
            };
        }
        function roleIconStyle(role) {
            return {
                color: (role && role.Color) ? '#fff' : '#4693c2'
            };
        }
        function roleAlert(role) {
            const assigned = role.DayNumbers.map(d => parseInt(d) || 0).reduce((a, b) => a + b, 0);
            const countOfJoined = role.vEmployees ? role.vEmployees.length : 0;
            if (countOfJoined === 0 && assigned > 0) {
                return "スタッフが配置されていません。";
            }
            if (countOfJoined > 0 && assigned === 0) {
                return "必要人数が設定されていません。";
            }
            if (countOfJoined === 0 && assigned === 0) {
                return "空の業務です";
            }
            return "";
        }
        function handleShowCountChange(role, event) {
            emit('update-show-count', role, event.target.checked);
        }
        function handleShowStaffCountChange(role, event) {
            emit('update-show-staff-count', role, event.target.checked);
        }
        function roleUrl(role) {
            return DashURL('role/' + role.ID);
        }
        function handleShowRoleEditPopup(event, roleId) {
            showRoleEditPopup(event, roleId);
        }
        (0, vue_3.onMounted)(() => {
            if (props.isGroupRolePage || !rolesTableBody.value) {
                return;
            }
            new sortablejs_1.default(rolesTableBody.value, {
                ...sortable_1.roleTableSortableOptions,
                onEnd: (event) => {
                    if (event.oldDraggableIndex === event.newDraggableIndex || event.oldDraggableIndex === undefined || event.newDraggableIndex === undefined) {
                        return;
                    }
                    emit('update-position', event.oldDraggableIndex, event.newDraggableIndex);
                },
            });
        });
        return (_ctx, _cache) => {
            return (__props.roles.length == 0)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                        (0, vue_2.createElementVNode)("p", { class: "empty-title h5" }, "業務がありません", -1 /* CACHED */),
                        (0, vue_2.createElementVNode)("p", { class: "empty-subtitle" }, "上の作成ボタンから業務を作成してください。", -1 /* CACHED */)
                    ]))]))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("table", _hoisted_4, [
                            (0, vue_2.createElementVNode)("thead", _hoisted_5, [
                                (0, vue_2.createElementVNode)("tr", _hoisted_6, [
                                    (!__props.isGroupRolePage)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_7, "並替"))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("th", null, "編集", -1 /* CACHED */)),
                                    _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("th", null, "業務名", -1 /* CACHED */)),
                                    (__props.isGroupRolePage)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_8, "使用中の拠点数"))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("th", null, "シフト", -1 /* CACHED */)),
                                    _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("th", null, "休憩時間", -1 /* CACHED */)),
                                    _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("th", null, "説明", -1 /* CACHED */)),
                                    _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("th", null, "時給", -1 /* CACHED */)),
                                    _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("th", null, "割り当て方法", -1 /* CACHED */)),
                                    _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("th", null, "種類", -1 /* CACHED */)),
                                    _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("th", null, "次の日休み", -1 /* CACHED */)),
                                    _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("th", { class: "font-sm" }, [
                                        (0, vue_2.createTextVNode)(" カウント "),
                                        (0, vue_2.createElementVNode)("div", { class: "th-sub" }, "(シフト表に表示)")
                                    ], -1 /* CACHED */)),
                                    _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("th", { class: "font-sm" }, [
                                        (0, vue_2.createTextVNode)(" 割当 "),
                                        (0, vue_2.createElementVNode)("div", { class: "th-sub" }, "(シフト表に表示)")
                                    ], -1 /* CACHED */)),
                                    _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("th", { class: "delete-btn-cell" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("tbody", {
                                ref_key: "rolesTableBody",
                                ref: rolesTableBody
                            }, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.roles, (role) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                        key: role.ID,
                                        class: (0, vue_2.normalizeClass)({ 'role-draggable': !__props.isGroupRolePage })
                                    }, [
                                        (!__props.isGroupRolePage)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_9, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                                    (0, vue_2.createVNode)(SortIcon_vue_1.default)
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("v-if", true),
                                        (0, vue_2.createElementVNode)("td", null, [
                                            (__props.isGroupRolePage)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                    key: 0,
                                                    onClick: ($event) => (emit('edit-role', role.ID)),
                                                    href: "#role-page-tabs"
                                                }, [...(_cache[13] || (_cache[13] = [
                                                        (0, vue_2.createElementVNode)("div", { class: "svg-container oplus-icon" }, [
                                                            (0, vue_2.createElementVNode)("svg", {
                                                                version: "1.1",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                                                x: "0px",
                                                                y: "0px",
                                                                "xml:space": "preserve",
                                                                viewBox: "0 0 85 85",
                                                                width: "25px"
                                                            }, [
                                                                (0, vue_2.createElementVNode)("path", {
                                                                    fill: "currentColor",
                                                                    d: "M26.3,55.6c-0.1,0.1-0.2,0.3-0.2,0.4l-0.8,11.3c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.5,0.1,0.7,0l10.2-4.7\n                    c0.1-0.1,0.3-0.1,0.3-0.3l17.8-25.3l-10.5-7.4L26.3,55.6z M59,22.1l-1.7-1.2c-2.4-1.7-6-0.9-7.9,1.8l-3.8,5.4l10.5,7.4l3.8-5.4\n                    C61.9,27.4,61.5,23.8,59,22.1z M60.2,80.1H25.6c-11,0-19.9-8.9-19.9-19.9V25.4c0-11,8.9-19.9,19.9-19.9h34.6\n                    c11,0,19.9,8.9,19.9,19.9v34.9C80.1,71.2,71.1,80.1,60.2,80.1z M25.6,9.1c-9,0-16.3,7.3-16.3,16.3v34.9c0,9,7.3,16.3,16.3,16.3\n                    h34.6c9,0,16.3-7.3,16.3-16.3V25.4c0-9-7.3-16.3-16.3-16.3H25.6z"
                                                                })
                                                            ])
                                                        ], -1 /* CACHED */)
                                                    ]))], 8 /* PROPS */, _hoisted_11))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                    key: 1,
                                                    href: roleUrl(role)
                                                }, [...(_cache[14] || (_cache[14] = [
                                                        (0, vue_2.createElementVNode)("div", { class: "svg-container oplus-icon" }, [
                                                            (0, vue_2.createElementVNode)("svg", {
                                                                version: "1.1",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                                                x: "0px",
                                                                y: "0px",
                                                                "xml:space": "preserve",
                                                                viewBox: "0 0 85 85",
                                                                id: "edit-icon",
                                                                width: "25px"
                                                            }, [
                                                                (0, vue_2.createElementVNode)("path", {
                                                                    fill: "currentColor",
                                                                    d: "M26.3,55.6c-0.1,0.1-0.2,0.3-0.2,0.4l-0.8,11.3c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.5,0.1,0.7,0l10.2-4.7\n                    c0.1-0.1,0.3-0.1,0.3-0.3l17.8-25.3l-10.5-7.4L26.3,55.6z M59,22.1l-1.7-1.2c-2.4-1.7-6-0.9-7.9,1.8l-3.8,5.4l10.5,7.4l3.8-5.4\n                    C61.9,27.4,61.5,23.8,59,22.1z M60.2,80.1H25.6c-11,0-19.9-8.9-19.9-19.9V25.4c0-11,8.9-19.9,19.9-19.9h34.6\n                    c11,0,19.9,8.9,19.9,19.9v34.9C80.1,71.2,71.1,80.1,60.2,80.1z M25.6,9.1c-9,0-16.3,7.3-16.3,16.3v34.9c0,9,7.3,16.3,16.3,16.3\n                    h34.6c9,0,16.3-7.3,16.3-16.3V25.4c0-9-7.3-16.3-16.3-16.3H25.6z"
                                                                })
                                                            ])
                                                        ], -1 /* CACHED */)
                                                    ]))], 8 /* PROPS */, _hoisted_12))
                                        ]),
                                        (0, vue_2.createElementVNode)("td", _hoisted_13, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                                (0, vue_2.createElementVNode)("div", {
                                                    class: "role-name text-popup d-flex",
                                                    style: (0, vue_2.normalizeStyle)(roleColorStyle(role))
                                                }, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                                        (role?.GroupWide)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", {
                                                                key: 0,
                                                                class: "tooltip tooltip-right role-group-star-icon",
                                                                style: (0, vue_2.normalizeStyle)(roleIconStyle(role)),
                                                                version: "1.1",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                                                x: "0px",
                                                                y: "0px",
                                                                "xml:space": "preserve",
                                                                viewBox: "0 0 85 85",
                                                                width: "25px"
                                                            }, [...(_cache[15] || (_cache[15] = [
                                                                    (0, vue_2.createElementVNode)("path", {
                                                                        fill: "currentColor",
                                                                        d: "M67.13,74.46H17.78c-4.04,0-7.33-3.29-7.33-7.33V17.78c0-4.04,3.29-7.33,7.33-7.33h49.35\n                      c4.04,0,7.33,3.29,7.33,7.33v49.35C74.46,71.17,71.17,74.46,67.13,74.46z M17.78,12.77c-2.76,0-5.01,2.25-5.01,5.01v49.35\n                      c0,2.77,2.25,5.01,5.01,5.01h49.35c2.77,0,5.01-2.25,5.01-5.01V17.78c0-2.76-2.25-5.01-5.01-5.01H17.78z M63.98,37.2\n                      c-0.11-0.35-0.42-0.6-0.78-0.67l-13.72-2.01L43.34,22.1c-0.32-0.67-1.45-0.67-1.8,0l-6.1,12.42l-13.72,2.01\n                      c-0.39,0.07-0.67,0.32-0.81,0.67c-0.11,0.39,0,0.78,0.28,1.02l9.91,9.67l-2.33,13.65c-0.07,0.39,0.07,0.78,0.39,0.99\n                      c0.18,0.14,0.39,0.21,0.56,0.21s0.32-0.07,0.49-0.14l12.24-6.42l12.28,6.42c0.32,0.18,0.74,0.18,1.02-0.07\n                      c0.32-0.21,0.49-0.6,0.42-0.99l-2.36-13.65l9.91-9.67C64.02,37.97,64.12,37.58,63.98,37.2z M63.21,36.53l-13.72-2.01L43.34,22.1\n                      c-0.32-0.67-1.45-0.67-1.8,0l-6.1,12.42l-13.72,2.01c-0.39,0.07-0.67,0.32-0.81,0.67c-0.11,0.39,0,0.78,0.28,1.02l9.91,9.67\n                      l-2.33,13.65c-0.07,0.39,0.07,0.78,0.39,0.99c0.18,0.14,0.39,0.21,0.56,0.21s0.32-0.07,0.49-0.14l12.24-6.42l12.28,6.42\n                      c0.32,0.18,0.74,0.18,1.02-0.07c0.32-0.21,0.49-0.6,0.42-0.99l-2.36-13.65l9.91-9.67c0.28-0.25,0.39-0.64,0.25-1.02\n                      C63.88,36.84,63.56,36.6,63.21,36.53z M63.98,37.2c-0.11-0.35-0.42-0.6-0.78-0.67l-13.72-2.01L43.34,22.1\n                      c-0.32-0.67-1.45-0.67-1.8,0l-6.1,12.42l-13.72,2.01c-0.39,0.07-0.67,0.32-0.81,0.67c-0.11,0.39,0,0.78,0.28,1.02l9.91,9.67\n                      l-2.33,13.65c-0.07,0.39,0.07,0.78,0.39,0.99c0.18,0.14,0.39,0.21,0.56,0.21s0.32-0.07,0.49-0.14l12.24-6.42l12.28,6.42\n                      c0.32,0.18,0.74,0.18,1.02-0.07c0.32-0.21,0.49-0.6,0.42-0.99l-2.36-13.65l9.91-9.67C64.02,37.97,64.12,37.58,63.98,37.2z"
                                                                    }, null, -1 /* CACHED */)
                                                                ]))], 4 /* STYLE */))
                                                            : (0, vue_2.createCommentVNode)("v-if", true)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(role.Name), 1 /* TEXT */),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", {
                                                        class: "role-alert-badge tooltip tooltip-left",
                                                        "data-tooltip": roleAlert(role)
                                                    }, [...(_cache[16] || (_cache[16] = [
                                                            (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-alert-circle zmdi-hc-lg text-error" }, null, -1 /* CACHED */)
                                                        ]))], 8 /* PROPS */, _hoisted_17), [
                                                        [vue_2.vShow, !__props.isGroupRolePage && (role.Type == 0 && roleAlert(role))]
                                                    ])
                                                ], 4 /* STYLE */)
                                            ])
                                        ]),
                                        (__props.isGroupRolePage)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_18, (0, vue_2.toDisplayString)(role.ActiveBranchCount), 1 /* TEXT */))
                                            : (0, vue_2.createCommentVNode)("v-if", true),
                                        (0, vue_2.createElementVNode)("td", _hoisted_19, (0, vue_2.toDisplayString)(role.From) + " ~ " + (0, vue_2.toDisplayString)(role.To), 1 /* TEXT */),
                                        (0, vue_2.createElementVNode)("td", {
                                            class: (0, vue_2.normalizeClass)(textGray(role.Rest))
                                        }, [
                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(role.Rest), 1 /* TEXT */)
                                        ], 2 /* CLASS */),
                                        (0, vue_2.createElementVNode)("td", {
                                            class: (0, vue_2.normalizeClass)(textGray(role.Purpose))
                                        }, (0, vue_2.toDisplayString)(role.Purpose || "無"), 3 /* TEXT, CLASS */),
                                        (0, vue_2.createElementVNode)("td", {
                                            class: (0, vue_2.normalizeClass)(textGray(role.Wage))
                                        }, (0, vue_2.toDisplayString)(renderRoleWageWithSign(role.Wage)), 3 /* TEXT, CLASS */),
                                        (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.Type ? "スタッフごと" : "曜日別"), 1 /* TEXT */),
                                        (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(slotTypesToString_1.slotTypeString)[role.SlotType]), 1 /* TEXT */),
                                        (0, vue_2.createElementVNode)("td", null, [
                                            (0, vue_2.createElementVNode)("i", {
                                                class: (0, vue_2.normalizeClass)(["zmdi zmdi-hc-lg", role.NextDayOff ? 'zmdi-check role-check-color' : 'zmdi-close'])
                                            }, null, 2 /* CLASS */)
                                        ]),
                                        (0, vue_2.createElementVNode)("td", null, [
                                            (0, vue_2.createElementVNode)("label", {
                                                class: (0, vue_2.normalizeClass)(["oplus-form-checkbox mx-auto", { 'disabled-btn': role.GroupWide && !__props.isGroupRolePage }])
                                            }, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": ($event) => ((role.ShowCount) = $event),
                                                    onChange: ($event) => (handleShowCountChange(role, $event))
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_20), [
                                                    [vue_2.vModelCheckbox, role.ShowCount]
                                                ])
                                            ], 2 /* CLASS */)
                                        ]),
                                        (0, vue_2.createElementVNode)("td", null, [
                                            (0, vue_2.createElementVNode)("label", {
                                                class: (0, vue_2.normalizeClass)(["oplus-form-checkbox mx-auto", { 'disabled-btn': role.GroupWide && !__props.isGroupRolePage }])
                                            }, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": ($event) => ((role.ShowStaffCount) = $event),
                                                    onChange: ($event) => (handleShowStaffCountChange(role, $event))
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21), [
                                                    [vue_2.vModelCheckbox, role.ShowStaffCount]
                                                ])
                                            ], 2 /* CLASS */)
                                        ]),
                                        (0, vue_2.createCommentVNode)(" 3 dots button "),
                                        (0, vue_2.createElementVNode)("td", {
                                            class: "delete-btn-cell",
                                            id: 'delete-button-' + role.ID
                                        }, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "svg-container oplus-icon",
                                                onClick: ($event) => (handleShowRoleEditPopup($event, role.ID))
                                            }, [
                                                (0, vue_2.createVNode)(KebabMenuIcon_vue_1.default)
                                            ], 8 /* PROPS */, _hoisted_23)
                                        ], 8 /* PROPS */, _hoisted_22)
                                    ], 2 /* CLASS */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */)
                        ])
                    ])
                ]));
        };
    }
});
